import router from "@/router";

const routes = [
  { // 酒景详情
    name: 'hotel-scenic-new-detail',
    path: '/hotel-scenic-new-detail',
    component: () => import('./hotel-scenic-new-detail.vue'),
  },
  { // 酒景列表
    name: 'hotel-scenic-new-list',
    path: '/hotel-scenic-new-list',
    component: () => import('./hotel-scenic-new-list.vue'),
  },

]

router.addRoutes(routes);

export default router;